/**
 * Vue组件安装工具
 * @description 提供Vue组件的安装函数
 */

import type { App, Plugin } from 'vue';

/**
 * 为组件添加install方法
 * @param component 组件
 * @param alias 全局属性别名
 * @returns 可安装的组件
 */
export const withInstall = <T>(component: T, alias?: string) => {
  const comp = component as any;
  comp.install = (app: App) => {
    app.component(comp.name || comp.displayName, component as any);
    if (alias) {
      app.config.globalProperties[alias] = component;
    }
  };
  return component as T & Plugin;
};
